import axios from "./axios";
import { handleApiError } from "./apiErrorHandler";

export default {

    getStats: async () => {
        try {
            const response = await axios.get("/database-console/stats");

            return {
                success: true,
                data: response.data
            };
        } catch (error) {
            return handleApiError(error);
        }
    },

    executeQuery: async (query) => {
        try {
            const response = await axios.post("/database-console/query", {
                query
            });

            return {
                success: true,
                data: response.data
            };
        } catch (error) {
            return handleApiError(error);
        }
    }

};